import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SucursalEcommerce } from '../ecommerce-generico/interfaces/sucursales-eccomerce.interface';

@Injectable({
  providedIn: 'root'
})
export class SucursalesService {

  private sucursales: SucursalEcommerce[] = [];
  private sucursalestemp: BehaviorSubject<SucursalEcommerce[]> = new BehaviorSubject([]);
  private sucursalactiva: SucursalEcommerce;
  private sucursalactivatemp: BehaviorSubject<SucursalEcommerce> = new BehaviorSubject(undefined);

  getSucursalActiva(): SucursalEcommerce {
    return this.sucursalactiva;
  }

  setSucursalActiva(sucursal: SucursalEcommerce): void {
    this.sucursalactiva = sucursal;
  }

  /** Emite el valor actual de sucursalactiva a los suscriptores (no se emite automáticamente en cada set). */
  emitSucursalActivaActual(): void {
    this.sucursalactivatemp.next(this.sucursalactiva);
  }

  getSucursalActivaProvider(): Observable<SucursalEcommerce> {
    return this.sucursalactivatemp.asObservable();
  }

  getSucursales(): SucursalEcommerce[] {
    return this.sucursales;
  }

  setSucursales(sucursales: SucursalEcommerce[]): void {
    this.sucursales = sucursales;
  }

  /** Emite el valor actual del listado de sucursales a los suscriptores. */
  emitSucursalesActuales(): void {
    this.sucursalestemp.next(this.sucursales);
  }

  getSucursalesProvider(): Observable<SucursalEcommerce[]> {
    return this.sucursalestemp.asObservable();
  }

  getSucursalPorNumero(sucursal: number): string {
    let nombre = '';
    this.sucursales.forEach(k => {
      if (sucursal == k.sucursal) {
        nombre = k.nombre;
      }
    });
    return nombre;
  }
}
